<template>
  <div class="d-flex flex-row align-items-center justify-content-stretch my-2">
    <div class="update-phones-row-title d-flex flex-column flex-grow-0 mr-2">
      <router-link :to="link" :disabled="processing">{{ item.name }}</router-link>
      <div v-if="companies">{{ companies }}</div>
    </div>

    <div class="update-phones-row-field flex-grow-0 mx-2">
      <phone-number-field
        ref="phoneField"
        :value="item.phone"
        :label="$t('Phone')"
        :disabled="processing"
        class="shadow"
        @update="onUpdate"
        @input="onInput"
      />
    </div>

    <div class="update-phones-row-original flex-grow-1 mx-2">{{ item.phone }}</div>

    <div
      :class="[
        'update-phones-row-updated',
        'mx-2',
        'd-flex',
        'flex-row',
        { 'update-phones-row-different': isDifferent },
      ]"
    >
      <b-checkbox :disabled="processing" :checked="selected" class="mr-1" @change="onSelect" />
      {{ innerValue || (isDifferent && '???') || '' }}
    </div>

    <div class="flex-grow-0 update-phones-row-actions ml-2">
      <b-button pill :disabled="processing" variant="success" class="btn-sm" @click="onSaveClick">
        <b-icon
          :icon="isProcessingThisItem ? 'arrow-clockwise' : 'check'"
          :animation="isProcessingThisItem ? 'spin' : null"
        />
        <span>{{ $t('Save') }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import PhoneNumberField from '@/components/form/PhoneNumberField';
import getRef from '@/utils/getRef';

export default {
  name: 'UpdatePhonesRow',

  components: {
    PhoneNumberField,
  },

  props: {
    item: {
      type: Object,
      requied: true,
    },
    entityType: {
      type: String,
      required: true,
    },
    processing: {
      type: Boolean,
      default: null,
    },
    processingId: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      innerValue: this.item.phone,
    };
  },

  computed: {
    isProcessingThisItem() {
      return this.processing && this.processingId === this.item._id;
    },

    isPerson() {
      return this.entityType === 'person';
    },

    isDifferent() {
      return this.item.phone !== this.innerValue;
    },

    companies() {
      return this.isPerson && this.item.companies && this.item.companies.length
        ? this.item.companies.map(({ name }) => name).join(', ')
        : null;
    },

    link() {
      return { name: this.isPerson ? 'EditPerson' : 'EditCompany', params: { _id: this.item._id } };
    },
  },

  methods: {
    setLocaleIfEmpty(locale) {
      const ref = getRef(this.$refs, 'phoneField');
      if (ref && ref.setLocaleIfEmpty) {
        ref.setLocaleIfEmpty(locale);
      }
    },

    onInput(value) {
      this.innerValue = value;
    },

    onUpdate(value) {
      this.innerValue = value;
    },

    onSaveClick() {
      this.$emit('save', this.item._id);
    },

    onSelect(value) {
      this.$emit('select', this.item._id, value);
    },
  },
};
</script>

<style scoped>
.update-phones-row-title {
  width: 350px;
}

.update-phones-row-field {
  width: 280px;
}

.update-phones-row-updated {
  width: 180px;
}

.update-phones-row-actions {
  width: 110px;
}

.update-phones-row-different {
  color: var(--bs-danger);
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/UpdatePhones/UpdatePhonesRow.vue